import React, { useEffect, useState } from "react";
import { Rocket } from "lucide-react";
import { api, formatINR } from "@/lib/api";
import { SEO } from "@/components/common/SEO";
import SmartImage from "@/components/common/SmartImage";
export default function Launches() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/launches").then((r)=>setItems(r.data)); }, []);
  return (<div className="max-w-7xl mx-auto px-6 lg:px-10 py-12" data-testid="launches-page">
    <SEO title="Upcoming Car Launches in India" description="Track upcoming launches with dates and expected prices."/>
    <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Upcoming</div>
    <h1 className="font-display text-4xl sm:text-5xl mt-2 tracking-tighter">Launches to watch.</h1>
    <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-6">{items.map((l)=>{
      const days = Math.max(0, Math.round((new Date(l.expected_date)-new Date())/86400000));
      return (<div key={l.model} data-testid={`launch-item-${l.model.toLowerCase().replace(/\s+/g,'-')}`} className="rounded-3xl overflow-hidden border border-border bg-card/30">
        <div className="aspect-[16/10] overflow-hidden"><SmartImage src={l.teaser_image} alt={l.model} label={l.model}/></div>
        <div className="p-5">
          <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">{l.brand} · {l.body_type} · {l.fuel_type || "TBA"}</div>
          <div className="font-display text-xl mt-2">{l.model}</div>
          <p className="text-sm text-muted-foreground mt-2">{l.description}</p>
          <div className="mt-4 flex items-center justify-between">
            <div className="font-mono text-sm">{formatINR(l.expected_price_min)} – {formatINR(l.expected_price_max)}</div>
            <div className="text-xs px-2 py-1 rounded-full bg-gradient-ai text-white"><Rocket className="w-3 h-3 inline -mt-0.5 mr-1"/>in {days} days</div>
          </div>
        </div>
      </div>);
    })}</div>
  </div>);
}
